import yup from 'src/libs/yup'

export const EventStepOneSchema = yup.object().shape({
  name: yup.string().required().label('Nome'),
  date: yup.date().required().label('Data do evento'),
  extraCost: yup.mixed().default(0),
  installmentConfig: yup.object().shape({
    enabled: yup.boolean().default(false),
    maxInstallments: yup
      .number()
      .min(1, 'Mínimo 1 parcela')
      .max(24, 'Máximo 24 parcelas')
      .when('enabled', {
        is: true,
        then: (schema) =>
          schema
            .required('Número máximo de parcelas é obrigatório')
            .typeError('Deve ser um número'),
        otherwise: (schema) => schema.optional(),
      }),
    minAmountForInstallment: yup.mixed().when('enabled', {
      is: true,
      then: (schema) => schema.required('Valor mínimo é obrigatório'),
      otherwise: (schema) => schema.optional(),
    }),
  }),
  webhook: yup.object().shape({
    enabled: yup.boolean().default(false),
    url: yup.string().when('enabled', {
      is: true,
      then: (schema) =>
        schema
          .required('URL do webhook é obrigatória')
          .url('URL inválida. Use o formato: https://seu-dominio.com/webhook'),
      otherwise: (schema) => schema.optional(),
    }),
  }),
  tefConfig: yup
    .object()
    .shape({
      enabled: yup.boolean().default(false),
      clientCode: yup.string().nullable().optional(),
      softDescriptor: yup
        .string()
        .nullable()
        .optional()
        .max(22, 'Soft Descriptor deve ter no máximo 22 caracteres'),
      endereco: yup
        .string()
        .nullable()
        .optional()
        .max(48, 'Endereço deve ter no máximo 48 caracteres'),
      cidade: yup
        .string()
        .nullable()
        .optional()
        .max(13, 'Cidade deve ter no máximo 13 caracteres'),
      uf: yup
        .string()
        .nullable()
        .optional()
        .when('enabled', {
          is: true,
          then: (schema) =>
            schema
              .length(2, 'UF deve ter 2 caracteres')
              .matches(/^[A-Za-z]*$/, 'UF deve conter apenas letras'),
          otherwise: (schema) => schema,
        }),
      pais: yup
        .string()
        .nullable()
        .optional()
        .when('enabled', {
          is: true,
          then: (schema) => schema.length(3, 'País deve ter 3 caracteres'),
          otherwise: (schema) => schema,
        }),
      cep: yup
        .string()
        .nullable()
        .optional()
        .matches(/^\d{0,8}$/, 'CEP deve conter até 8 dígitos (sem hífen)'),
      mcc: yup
        .string()
        .nullable()
        .optional()
        .matches(/^\d{0,4}$/, 'MCC deve conter até 4 dígitos'),
      cnpj: yup
        .string()
        .nullable()
        .optional()
        .matches(/^\d{0,14}$/, 'CPF/CNPJ deve conter apenas dígitos'),
      telefone: yup
        .string()
        .nullable()
        .optional()
        .matches(/^\d{0,11}$/, 'Telefone deve conter apenas dígitos (com DDD)'),
      nomeCompleto: yup
        .string()
        .nullable()
        .optional()
        .max(60, 'Razão Social deve ter no máximo 60 caracteres'),
      tipoPessoa: yup
        .string()
        .nullable()
        .optional()
        .oneOf(['', 'F', 'J'], 'Tipo de Pessoa deve ser F ou J'),
    })
    .default({}),
})

export const EventStepTwoSchema = yup.object().shape({
  managers: yup.array().of(yup.mixed()).nullable().optional(),
})
